"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableUtils = require("./TableUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * ColGroup inside Table
 */
var TableColGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableColGroup, _React$Component);

  function TableColGroup() {
    _classCallCheck(this, TableColGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableColGroup).apply(this, arguments));
  }

  _createClass(TableColGroup, [{
    key: "renderCol",
    value: function renderCol(key, colWidth) {
      return _react.default.createElement("col", {
        key: key,
        style: {
          width: colWidth,
          minWidth: colWidth
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columnKey = _this$props.columnKey,
          editRow = _this$props.editRow,
          rowAction = _this$props.rowAction,
          rowExpand = _this$props.rowExpand,
          rowSelection = _this$props.rowSelection,
          structure = _this$props.structure;
      var cols = [];

      if (rowSelection) {
        cols.push(this.renderCol('rowSelection'));
      }

      var columns = (0, _TableUtils.flattenResizableColumns)(this.props.columns);

      for (var i = 0; i < columns.length; i++) {
        var column = columns[i];
        var columnWidth = structure && structure.columnWidths ? structure.columnWidths[column[columnKey]] : undefined;
        cols.push(this.renderCol("col-".concat(i), columnWidth));
      }

      if (rowAction) {
        cols.push(this.renderCol('rowAction'));
      }

      if (rowExpand) {
        cols.push(this.renderCol('rowExpand'));
      }

      if (editRow) {
        cols.push(this.renderCol('colAction', 1));
      }

      return _react.default.createElement("colgroup", null, cols);
    }
  }]);

  return TableColGroup;
}(_react.default.Component);

exports.default = TableColGroup;
TableColGroup.propTypes = {
  /**
   * Key used to uniquely identify a column
   */
  columnKey: _propTypes.default.string,

  /**
   * Array of column objects
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Object with edit row mode options
   */
  editRow: _propTypes.default.object,

  /**
   * Object with row action options
   */
  rowAction: _propTypes.default.object,

  /**
   * Object with row expand options
   */
  rowExpand: _propTypes.default.object,

  /**
   * Object with row selection options
   */
  rowSelection: _propTypes.default.object,

  /**
   * Structure object
   */
  structure: _propTypes.default.object
};